<div class="ag-grid-editor-date" (keydown.enter)="handleSubmit($event)">
  <mat-datepicker #shipByDatepicker></mat-datepicker>
  <div class="d-flex">
    <input
      class="ag-grid-editor-date__field grow"
      [disabled]="loading$ | async"
      placeholder="M/D/YYYY"
      [matDatepicker]="shipByDatepicker"
      [(ngModel)]="value"
      (dateChange)="handleDateChange()"
      (input)="handleInputChange($event)"
    />
    <button
      type="button"
      class="ag-grid-editor-date__picker-toggle lum-button lum-button--link"
      [disabled]="loading$ | async"
      (click)="handlePickerToggleClick($event, shipByDatepicker)"
      ><lum-ui-icon icon="calendar-mark"></lum-ui-icon
    ></button>
  </div>
  <mat-progress-spinner
    *ngIf="loading$ | async"
    class="ag-grid-editor-date__loader"
    [diameter]="loaderDiameter"
    mode="indeterminate"
    [style]="'--js-loader-diameter:' + loaderDiameter + 'px;'"
  ></mat-progress-spinner>
</div>
